/**
 * Time signature ("BEAT") utilities.
 *
 * Each pattern describes:
 *  - `beats`   : how many subdivisions form a measure (drives the click loop)
 *  - `accents` : 0-based indices that should be primary-accented (loud "down")
 *  - `mids`    : 0-based indices for secondary accents (medium volume), only used
 *                by compound meters (6/8, 12/8) where the user expects an audible
 *                pulse on the start of each grouping.
 *
 * Notes for the metronome:
 *  - For 2/4, 3/4, 4/4 (simple meters), only beat 1 is loud; the rest play at
 *    normal level.
 *  - For 6/8 → beat 1 loud, beat 4 medium.
 *  - For 12/8 → beat 1 loud, beats 4, 7, 10 medium.
 */
export const BEAT_OPTIONS = ["2/4", "3/4", "4/4", "6/8", "12/8"];

const PATTERNS = {
  "2/4": { beats: 2, accents: [0], mids: [] },
  "3/4": { beats: 3, accents: [0], mids: [] },
  "4/4": { beats: 4, accents: [0], mids: [] },
  "6/8": { beats: 6, accents: [0], mids: [3] },
  "12/8": { beats: 12, accents: [0], mids: [3, 6, 9] },
};

export const DEFAULT_BEAT = "4/4";

export const normalizeBeat = (raw) => {
  if (!raw) return DEFAULT_BEAT;
  return BEAT_OPTIONS.includes(raw) ? raw : DEFAULT_BEAT;
};

export const getBeatPattern = (raw) => PATTERNS[normalizeBeat(raw)];

/**
 * For metronome scheduling: returns 0 = loud, 1 = medium, 2 = quiet
 * given the current beat index inside a measure.
 */
export const beatAccentLevel = (beatSig, beatIdxInMeasure) => {
  const p = getBeatPattern(beatSig);
  if (p.accents.includes(beatIdxInMeasure)) return 0;
  if (p.mids.includes(beatIdxInMeasure)) return 1;
  return 2;
};
